import EntityName from "data/util/EntityName";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import HiddenFieldStore from "data/HiddenFieldStore";

const isFieldHidden = (entityKey, fieldKeyOrInfo) => {
    if (entityKey == null) {
        throw new Error("isFieldHidden doesn't accept a null entityKey");
    }
    if (fieldKeyOrInfo == null) {
        throw new Error("isFieldHidden doesn't accept a null fieldKeyOrInfo");
    }
    // is it hideable?
    const fi = typeof fieldKeyOrInfo === "string"
        ? entityFieldMetaStore.getInfo(entityKey, fieldKeyOrInfo)
        : fieldKeyOrInfo;
    if (!fi.userHideable) {
        return false;
    }
    const en = new EntityName(entityKey);
    // is it included in the hidden fields preference?
    if (!HiddenFieldStore.isIncluded(en.implKey, en.bareEntityKey, fi.key)) {
        return false;
    }
    // it's hidden!
    return true;
};

export default isFieldHidden;



// WEBPACK FOOTER //
// ./app/data/util/isFieldHidden.js